const TextTypes = {
  EMAIL: "email",
  PASSWORD: "password",
  NAME: "name",
  PIN: "PIN",
  PLAIN: "plain"
};

export default TextTypes;